import type { CSSProperties, MouseEvent } from 'react';

const INTERACTIVE = 'a, button, input, select, textarea, label, [role="menu"], [role="menuitem"], [role="dialog"]';

/** Pointer cursor for a row that navigates; hover colour comes from `Table highlightOnHover`. */
export const rowStyle: CSSProperties = { cursor: 'pointer' };

/**
 * Row click handler: navigates unless the click landed on something interactive.
 * A ctrl/meta click opens the row's own link (its first anchor) in a new tab.
 */
export function rowClick(go: () => void) {
  return (e: MouseEvent<HTMLTableRowElement>) => {
    if ((e.target as HTMLElement).closest(INTERACTIVE)) return;
    if (e.ctrlKey || e.metaKey) {
      const a = e.currentTarget.querySelector<HTMLAnchorElement>('a[href]');
      if (a) window.open(a.href, '_blank');
      return;
    }
    go();
  };
}
